import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';

export interface IInsuredElementApi {
  getSellingPointList(): Promise<APIResponse<any>>;
  getInsuredGoods(): Promise<APIResponse<any>>;
}

export class InsuredElementApi implements IInsuredElementApi {
  async getSellingPointList(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('transverse/sellingPoints'));
  }

  async getInsuredGoods(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('sherpaSim/brandModel'));
  }
}
